export default "__VITE_ASSET__oC0urJ8m__"